import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden mt-16">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20airy%20modern%20workspace%20scene%20with%20an%20open%20laptop%20displaying%20a%20spreadsheet%20interface%20surrounded%20by%20colorful%20fashion%20accessories%20a%20coffee%20cup%20and%20a%20small%20succulent%20plant%20on%20a%20warm%20wooden%20desk%20natural%20sunlight%20streaming%20through%20a%20window%20creating%20soft%20highlights%20and%20long%20shadows%20editorial%20lifestyle%20photography%20with%20a%20vibrant%20fresh%20and%20organized%20composition&width=1920&height=1080&seq=hero-v2-unique-88&orientation=landscape"
          alt="Vigorbuy Spreadsheet product comparison and discovery system"
          title="Vigorbuy Spreadsheet product comparison system"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-accent-300 text-sm md:text-base font-label tracking-wide mb-4 md:mb-5 animate-[fadeInUp_0.6s_ease-out]">
            Structured Product Intelligence
          </p>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5 md:mb-6 animate-[fadeInUp_0.6s_ease-out_0.1s]">
            The Smart Way to Compare, Track, and
            <br className="hidden md:block" />
            Discover Products Instantly
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 md:mb-10 animate-[fadeInUp_0.6s_ease-out_0.2s] leading-relaxed">
            A structured spreadsheet intelligence system designed to help you analyze products,
            compare options, and make faster, safer decisions — all in one organized view.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 animate-[fadeInUp_0.6s_ease-out_0.3s]">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-label font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Vigorbuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/60 text-white text-sm md:text-base font-label font-semibold hover:bg-white/10 hover:border-white transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Buy It Now
            </a>
            <Link
              to="/vigorbuy-spreadsheet-guide"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/40 text-white/90 text-sm md:text-base font-label font-medium hover:bg-white/10 hover:border-white/60 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Shopping Guide
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-[bounce_2s_infinite]">
        <div className="w-8 h-12 rounded-full border-2 border-white/40 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-white/60 animate-[scrollDot_1.5s_ease-in-out_infinite]"></div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes scrollDot {
          0%, 100% { transform: translateY(0); opacity: 0.3; }
          50% { transform: translateY(8px); opacity: 1; }
        }
      `}</style>
    </section>
  );
}